import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Field } from "react-final-form";
import _ from "lodash";

export default function DataFilterCollection({
    name,
    label,
    collection,
    fieldValue,
    extraQuery,
    required = false,
    databaseFilter = false,
    doFilter,
    sx,
}) {
    const [lista, setLista] = useState([]);

    useEffect(() => {
        let observer = null;

        if (collection) {
            let newCollection = collection;
            newCollection = newCollection.where("status", "==", "ATIVO");
            if (extraQuery) {
                newCollection = extraQuery(newCollection)
            }
            observer = newCollection.onSnapshot(
                (qs) => {
                    let l = [];
                    if (!qs.empty) {
                        qs.forEach((doc) => {
                            let newV = doc.data();
                            if (
                                _.get(newV, fieldValue) &&
                                !l.map((v) => _.get(v, fieldValue)).includes(_.get(newV, fieldValue))
                            ) {
                                l.push(newV);
                            }
                        });
                    }
                    setLista(["", ...l]);
                },
                (err) => {
                    console.error(`createSnapCollection error: ${err}`);
                }
            );
        }

        return () => {
            if (observer) observer();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [collection, fieldValue]);

    return (
        <Field name={name} required>
            {(props) => (
                <Autocomplete
                    getOptionLabel={(option) => {
                        if (option) {
                            return _.get(option, fieldValue);
                        } else {
                            return "";
                        }
                    }}
                    isOptionEqualToValue={(option, value) => option.uid === value.uid}
                    options={lista}
                    value={props.input.value}
                    onChange={(event, value) => {
                        // Necessário para passar os valores do MUI para o Final Form.
                        props.input.onChange(value);
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            variant="standard"
                            sx={{ mt: 1 }}
                            error={props.meta.error && props.meta.touched}
                            helperText={props.meta.touched ? props.meta.error : ""}
                        />
                    )}
                    sx={{ display: "inline-block", width: "100%", ...sx }}
                />
            )}
        </Field>
    );
}
